let callbacks = [];

export function addCallback(cb) {
  callbacks.push(cb);
  return cb;
}

export function removeCallback(cb) {
  callbacks = callbacks.filter(c => c !== cb);
}

export const observer = new ResizeObserver(entries => {
  for (let entry of entries) {
    const dimensions = (() => {
      if (entry.contentBoxSize) {
        const contentBoxSize = Array.isArray(entry.contentBoxSize)
          ? entry.contentBoxSize[0]
          : entry.contentBoxSize;

        return {
          width: contentBoxSize.inlineSize,
          height: contentBoxSize.blockSize,
        };
      }

      return {
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      };
    })();

    callbacks.forEach(cp => {
      cp(dimensions);
    });
  }
});

export default {
  addCallback,
  removeCallback,
  observer,
};
